import * as React from 'react';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { Box } from '@mui/system';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import Plant from 'benchmarking-domain/plant';
import { DataGridArrayColumnSortComparator, DataGridInMemory } from 'components/core/shared/data-grid-in-memory';
import { nameOf } from 'helpers/nameof';
import { useNavigate } from 'react-router-dom';

import { paths } from '../../../paths';

interface PlantsTableProps {
  rows?: Plant[];
}

export function PlantsTable({ rows = [] }: PlantsTableProps): React.JSX.Element {
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      field: nameOf<Plant>('name'),
      headerName: 'Name',
      minWidth: 150,
    },
    {
      field: nameOf<Plant>('managers'),
      headerName: 'Managers',
      flex: 1,
      minWidth: 300,
      sortComparator: DataGridArrayColumnSortComparator,
      renderCell: (params: GridRenderCellParams<Plant, string[]>) => (
        <Box sx={{ display: 'inline-flex', flexWrap: 'wrap', gap: 1, padding: 1 }}>
          {params.value?.map((manager) => <Chip key={manager} color="default" label={manager} size="small" />)}
        </Box>
      ),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      minWidth: 150,
      sortable: false,
      filterable: false,
      renderCell: (params: GridRenderCellParams<Plant>) => {
        return (
          <Stack direction="row" spacing={1} sx={{ marginY: 1 }}>
            <Button
              variant="contained"
              onClick={() => {
                navigate(paths.app.client.plants.getDetailsUrl(params.row.id));
              }}
            >
              View&nbsp;plant
            </Button>
          </Stack>
        );
      },
    },
  ];

  return <DataGridInMemory columns={columns} rows={rows} searchPlaceholder="Search plants" />;
}
